<div class="tree-view-bg-white cursor-default  mt-3 mb-5 ">
    <ngx-org-chart [nodes]="nodes" direction="vertical"></ngx-org-chart>
</div>